import React, { ChangeEvent } from 'react';
import { FormattedMessage } from 'react-intl';

export interface IPreventJoinBeforeValues {
    preventJoinBefore: number;
    preventJoinEnabled: boolean;
}
export interface IPreventJoinBeforeProps extends IPreventJoinBeforeValues {
    togglePreventJoinBefore: (e: ChangeEvent<HTMLInputElement>) => void;
    onPreventJoinBeforeChange: (e: ChangeEvent<HTMLInputElement>) => void;
    getPreventJoinBeforeValidationError: () => string | null;
}

export const PreventJoinBefore = (props: IPreventJoinBeforeProps) => {
    return (
        <>
            <div className='m-top-10px m-bottom-0px'>
                <div>
                    <label className='cursor-point'>
                        <input
                            type='checkbox'
                            className='m-top-8px m-right-8px'
                            checked={props.preventJoinEnabled}
                            onChange={props.togglePreventJoinBefore}
                        />
                        <FormattedMessage
                            id='oe.meeting.moreThanMinutesStart'
                            defaultMessage='Prevent attendees from joining meetings more than'
                            description='Label text'
                        />
                        <input
                            disabled={!props.preventJoinEnabled}
                            placeholder='XX'
                            type='number'
                            min='1'
                            max='99'
                            value={props.preventJoinEnabled ? props.preventJoinBefore : ''}
                            className='oe-form-field__control m-left-4px m-right-4px w-fit-content'
                            onChange={props.onPreventJoinBeforeChange}
                            style={{display: 'inline'}}
                        />
                        <FormattedMessage
                            id='oe.meeting.moreThanMinutesEnd'
                            defaultMessage='minutes before the meeting starts'
                            description='Label text'
                        />

                    </label>
                </div>
                {props.getPreventJoinBeforeValidationError() && <span className='oe-form-field__error'>{props.getPreventJoinBeforeValidationError()}</span>}
            </div>
        </>
    );
};
